var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.493,
    height: 188.309,
    viewBox: "0 0 187.493 188.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_icon",
    transform: "translate(0 -0.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M102.931,46.4H25.592a4.4,4.4,0,0,1-3.1-7.451l29.8-29.8a31.144,31.144,0,0,1,44.009,0L111.922,24.77A12.716,12.716,0,0,1,102.931,46.4Z",
    transform: "translate(31.531)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M29.969,57.16h77.388a4.4,4.4,0,0,1,3.1,7.451l-29.8,29.8a31.144,31.144,0,0,1-44.108.1L20.928,78.891a12.741,12.741,0,0,1,9.04-21.731Z",
    transform: "translate(25.54 84.736)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M23.7,39.41H155.459c5.762,0,8.668,8.866,4.57,14.032L144.034,73.758a5.911,5.911,0,0,1-4.595,2.484H39.7a5.861,5.861,0,0,1-4.57-2.484L19.16,53.442C15.037,48.326,17.918,39.41,23.7,39.41Z",
    transform: "translate(25.546 58.402)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M1.987,44.429,18.727,24.114A6.159,6.159,0,0,1,23.52,21.63H127.682a6.159,6.159,0,0,1,4.793,2.484l16.739,20.316c4.272,5.166,1.242,14.032-4.793,14.032H6.781C.746,58.462-2.26,49.6,1.987,44.429Z",
    transform: "translate(0 32.024)",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/logo_icon-white.33a875e00b271fc988c25c4a1e486aa6.svg";
export { ForwardRef as ReactComponent };